import React, { FC, Fragment } from "react";
import { Typography, Stack, Box } from "@mui/material";
import { TextAreaField } from "./textArea";
import { InputField } from "./input";
import { CustomSelectField } from "./customSelect";
import { CustomTextArea } from "../../../components/fields/CustomTextArea/CustomTextArea";

const ExpertiseInfo: FC = () => {
  return (
    <Fragment key="expertise info">
      <Typography
        variant="h4"
        sx={{
          color: "var(--Base-1000, #000)",
          fontFamily: "CircularStdBlack",
          fontSize: "24px",
          fontStyle: "normal",
          fontWeight: 900,
          lineHeight: "132%",
        }}
      >
        Expertise
      </Typography>
      <hr style={{ color: "var(--border)", marginTop: "16px" }} />

      <Stack width={1} spacing={3} mb={3} mt={2}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={3} width={1}>
          <Box flex={1} width="100%">
            {" "}
            <InputField
              name="jobTitle"
              label="Job Title"
              placeholder="Job Title"
            />
          </Box>
          <Box flex={1} width="100%" sx={{ marginTop: "5px !important" }}>
            {" "}
            <InputField
              name="company"
              label="Company Name"
              required={false}
              placeholder="Company Name"
            />
          </Box>
        </Stack>
        <Stack direction="row" width={1} spacing={3}>
          <CustomSelectField
            name="employmentStatus"
            label="Employment Status"
            options={[
              "Full time",
              "Part time",
              "Unemployed",
              "Self-Employed",
              "Retired",
            ]}
          />
        </Stack>
        <Stack direction="row" width={1} spacing={3}>
          <CustomSelectField
            name="openToPromotional"
            label="Are you open to being featured in our promotional materials and events?"
            options={["Yes", "No"]}
          />
        </Stack>

        <CustomTextArea
          name="areasOfExpertise"
          label="Briefly describe any specific area(s) of expertise within your profession and how it can contribute to our expert community."
          rows={5}
          required
        />
        <CustomTextArea
          name="previousContent"
          label="Please provide links to any previous content you've created or any brand collaborations you have been involved in."
          rows={5}
          required={false}
        />
      </Stack>
    </Fragment>
  );
};

export default ExpertiseInfo;
